/**
 * Chugs of the Week — Inline Video Player
 * Plays video inside the card thumbnail container instead of a modal
 */
(function() {
  'use strict';

  // Play: replace thumbnail with inline video
  document.addEventListener('click', function(e) {
    var playBtn = e.target.closest('.cotw__play-btn');
    if (!playBtn) return;

    e.preventDefault();

    var thumbnail = playBtn.closest('.cotw__thumbnail');
    if (!thumbnail) return;

    var videoSrc = playBtn.getAttribute('data-video-src');
    var videoType = playBtn.getAttribute('data-video-type') || 'video/mp4';
    if (!videoSrc) return;

    // Don't re-create if already playing
    if (thumbnail.querySelector('.cotw__inline-video')) return;

    // Create video wrapper
    var wrapper = document.createElement('div');
    wrapper.className = 'cotw__inline-video';

    // Create video element
    var video = document.createElement('video');
    video.setAttribute('controls', '');
    video.setAttribute('autoplay', '');
    video.setAttribute('playsinline', '');

    var source = document.createElement('source');
    source.src = videoSrc;
    source.type = videoType;
    video.appendChild(source);

    // Create close button
    var closeBtn = document.createElement('button');
    closeBtn.className = 'cotw__inline-close';
    closeBtn.setAttribute('aria-label', 'Close video');
    closeBtn.innerHTML = '&times;';

    wrapper.appendChild(video);
    wrapper.appendChild(closeBtn);
    thumbnail.appendChild(wrapper);

    // Hide poster and play button
    thumbnail.classList.add('cotw__thumbnail--playing');

    video.play().catch(function() {});

    // Auto-close when video ends
    video.addEventListener('ended', function() {
      closeThumbnailVideo(thumbnail);
    });
  });

  // Close inline video
  document.addEventListener('click', function(e) {
    var closeBtn = e.target.closest('.cotw__inline-close');
    if (!closeBtn) return;

    e.preventDefault();
    e.stopPropagation();

    var thumbnail = closeBtn.closest('.cotw__thumbnail');
    if (thumbnail) closeThumbnailVideo(thumbnail);
  });

  function closeThumbnailVideo(thumbnail) {
    var wrapper = thumbnail.querySelector('.cotw__inline-video');
    if (wrapper) {
      var video = wrapper.querySelector('video');
      if (video) {
        video.pause();
        video.removeAttribute('src');
        video.load();
      }
      wrapper.remove();
    }
    thumbnail.classList.remove('cotw__thumbnail--playing');
  }
})();
